// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VModal from 'vue-js-modal';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

import store from './javascript/store';
import common from './javascript/common';
import * as config from './javascript/config';
// font-awesome
import { library } from "@fortawesome/fontawesome-svg-core"; 
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"; 
import { fas } from "@fortawesome/free-solid-svg-icons"; 
import { far } from "@fortawesome/free-regular-svg-icons";
import VueAwesomeSwiper from 'vue-awesome-swiper';
library.add(far); 
library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueAwesomeSwiper);
Vue.use(VModal, { dynamic: true})
Vue.config.productionTip = false;

export const EventBus = new Vue();

const MyPlugin = {
  install(Vue, options) {
    Vue.mixin({
      mounted() {
        setTimeout(() => {
          this.$root.$el.onclick = () => {
            // alert("element clicked");
            // 로그인 여부에만 작동하게끔 
            this.$store.commit('reset_logout_timer_true', {
                value: ''
            });
          };
        });
      }
    });
  }
};
Vue.use(MyPlugin);

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  store,
  router,
  common,
  components: { App },
  template: '<App/>',
})
window.app = vm;


// WEBPACK FOOTER //
// ./src/main.js